import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ThirdPartyIntegration,
  availabilityLabel,
  getIntegrationById,
} from 'src/app/shared/constants/third-party-integrations';

@Component({
  selector: 'app-integration-setup',
  templateUrl: './integration-setup.component.html',
  styleUrls: ['./integration-setup.component.css'],
})
export class IntegrationSetupComponent implements OnInit {
  integration?: ThirdPartyIntegration;
  availabilityLabel = availabilityLabel;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.data['integrationId'] as string;
    this.integration = getIntegrationById(id);
    if (!this.integration) {
      this.router.navigateByUrl('/home/integrations');
    }
  }

  backToHub(): void {
    this.router.navigateByUrl('/home/integrations');
  }

  openLink(route: string): void {
    this.router.navigateByUrl(route);
  }

  isPlanned(): boolean {
    return this.integration?.availability === 'planned';
  }
}
